import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronUp, Filter, RotateCcw } from "feather-icons-react";
// import Table from "../../../core/pagination/datatableReports";
import {Table, Tooltip} from "antd";
import { useEffect } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { setheadertoggle } from "../../../redux/toggle";

import {
  exportExcel,
  exportPDF,
  HandlePrint,
  renderTooltip,
} from "../../../redux/helper";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSettings,
  fetchCustomer,
} from "../../../redux/userSetting";
import { DatePicker, Select, Tabs } from "antd";
import { getCategoryWiseReport, getConsolidatedReportSectionwise, getitemWiseSalesReport } from "../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import dayjs from "dayjs";
import { useMemo } from "react";
import LoadingUtils from "../../../core/utils/LoadingUtils";
import {
  exportMasterExcel,
  exportMasterPDF,
  printMasterReport,
} from "../../../core/utils/CategoryGroupUtils";

const CategorySalesReport = () => {
  const [searchText, setSearchText] = useState("");
  const [reportData, setreportData] = useState([]);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const { branch } = useSelector((state) => state.branchlist);
  const dispatch = useDispatch();
   const [decimalpoints, setDecimalPoints] = useState(2);
    const {settingList} = useSelector((state) => state.usersetting);
    const { companyInfolist } = useSelector((state) => state.companyInfo);
  const [activeTab, setActiveTab] = useState("1");
  const { TabPane } = Tabs;

  const { togglehead } = useSelector((state) => state.headerToggle);
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);

    setToDate(null); // reset to date when from date changes
  };
  const handleToDateChange = (date) => {
    setToDate(date);
  };
  useEffect(() => {
    //setreportData(salesReportConsol);
    handleReportList();
     dispatch(fetchUnit());
        dispatch(fetchProduct(branch));
        dispatch(fetchTax());
        dispatch(fetchSettings(branch));
    
        const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
        const currfmt = match ? match[0]?.length - 1 : 0;
        setDecimalPoints(currfmt);
  }, [branch]);
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const handleReportList = async () => {
    setloading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    const formattedfromDate = dayjs(fromDate)
      .startOf("day")
      .format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).endOf("day").format("YYYY-MM-DD");
    const Filters = new Filterclass();
    DatatablePagingParameters.PageSize = -1;
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    Filters.PaymentType = "";
    Filters.Waiter = "";
    Filters.Counter = "";
    Filters.Section = "";
    try {
      const response = await getCategoryWiseReport({
        DatatablePagingParameters,
        Filters,
      });
console.log(response.data.itemWiseSalesReportDetail,"categorywise")
      const dataArray = [response.data];
      console.log("object",dataArray)
      setloading(false);
      if (Array.isArray(dataArray)) {
       
        const data = dataArray?.map((item) => {
            return (item.itemWiseSalesReportDetail || [])
              .filter((e) => !e.cancelled && !e.refund)
              .filter((e) => e?.paymentType !== 5)
              .map((e) => {
                return {
                  billdate:e.billDate,
                  quantity:e.quantity,
                  category: e.product?.category?.name, // Updated from section to category
                  netTotal: e.total,
                };
              });
          });
          
      //  console.log("dddaaataaa",data)
     console.log(reportData,"categorydaaaata");
     
        setreportData(data[0]);
      } else {
        setreportData([]);
      }
    } catch (error) {
      setloading(false);
      console.log(error?.response?.data?.Message || "something went wrong");
      setreportData([]);
    }
   
  };

 
  
  


  const { branches, categories, summaryData, categoryGrandTotal, finalData,grandQuantity,grandTotal,totalQuantity } = useMemo(() => {
    const safeReportData = reportData || [];
  
    // Extract unique branches and categories
    const branches = [...new Set(safeReportData.map((item) => item.branch))];
    const categories = [...new Set(safeReportData.map((item) => item.category))];
  
    // Compute category-wise summary data
    const summaryData = categories.map((category) => {
      const filteredItems = safeReportData.filter((item) => item.category === category);
  
      return {
        key: category,
        category,
        categoryTotal: filteredItems.reduce((sum, item) => sum + (item.netTotal || 0), 0),
        totalQuantity: filteredItems.reduce((sum, item) => sum + (item.quantity || 0), 0),
      };
    });
  
    // Calculate grand totals for categories
    const categoryGrandTotal = summaryData.reduce((sum, row) => sum + row.categoryTotal, 0);
    const totalQuantity = summaryData.reduce((sum, row) => sum + row.totalQuantity, 0);
  
    // Append total row in summaryData
    // summaryData.push({
    //   key: "total",
    //   category: "Total",
    //   categoryTotal: categoryGrandTotal,
    //   totalQuantity,
    // });
  
    // ✅ Step 1: Group reportData by `billdate` and `category`
    const groupedData = safeReportData.reduce((acc, item) => {
      const key = `${item.billdate}-${item.category}`;
  
      if (!acc[key]) {
        acc[key] = { ...item }; // Copy the object
      } else {
        acc[key].netTotal += item.netTotal; // Sum netTotal
        acc[key].quantity += item.quantity; // Sum quantity
      }
  
      return acc;
    }, {});
  
    // ✅ Step 2: Convert grouped object to array
    const finalData = Object.values(groupedData);
  
    // ✅ Step 3: Compute grand totals for grouped data
    const grandTotal = finalData.reduce((sum, row) => sum + (row.netTotal || 0), 0);
    const grandQuantity = finalData.reduce((sum, row) => sum + (row.quantity || 0), 0);
  
    console.log(finalData); // ✅ Debugging: check grouped data
    console.log(grandTotal, "Grand Total");
    console.log(grandQuantity, "Grand Quantity");
  
    // ✅ Step 4: Now `finalData` is ready, so we can safely create `modifiedReportData`
    // const modifiedReportData = [
    //   ...finalData,
    //   {
    //     key: "grand_total",
    //     branch: "Grand Total",
    //     category: "Total",
    //     netTotal: grandTotal,
    //     quantity: grandQuantity,
    //     className: "fw-bold text-dark",
    //     fixed: "bottom", // Helps fix it in Ant Design
    //   },
    // ];
  
    return { branches, categories, summaryData, categoryGrandTotal, finalData,grandQuantity,grandTotal,totalQuantity };
  }, [reportData]);
  

 const modifiedList = Array.isArray(finalData)
    ? finalData?.filter((value) =>
        value.category?.toLowerCase().includes(searchText?.toLowerCase())
      )
    : [];

 

const columns = [
 
  // {
  //   title: "Bill Date",
  //   key: "billdate",
  //   dataIndex: "billdate",
  //   render: (text) => {
  //     if (!text) return "-"; // Display a placeholder if the date is missing
  
  //     const date = new Date(text);
  //     if (isNaN(date.getTime())) return "-"; // Handle invalid dates
  
  //     return date.toLocaleDateString("en-GB", {
  //       day: "2-digit",
  //       month: "short",
  //       year: "numeric",
  //     });
  //   },
  //   sorter: (a, b) => new Date(a.billdate) - new Date(b.billdate), // Proper sorting
  // },
  {
    title: "Bill Date",
    key: "billdate",
    dataIndex: "billdate",
    render: (text) => {
      if (!text) return "-"; // Display a placeholder if the date is missing
  
      const date = new Date(text);
      if (isNaN(date.getTime())) return "-"; // Handle invalid dates
  
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    sorter: (a, b) => {
      const dateA = new Date(a.billdate).getTime() || 0;
      const dateB = new Date(b.billdate).getTime() || 0;
      return dateA - dateB; // Ascending order (oldest to newest)
    },
    defaultSortOrder: "ascend", // Set default sorting order
  },
  
    // {
    //   title: "Category",
    //   dataIndex: "category",
    //   key: "category",
    //   render: (text, record) =>
    //     record.key === "categoryTotal" ? <strong>{text}</strong> : text,
    // },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category || "").localeCompare(b.category || ""),
      defaultSortOrder: "ascend", // Sort A-Z by default
      render: (text, record) =>
        record.key === "categoryTotal" ? (
          <strong>{text}</strong>
        ) : (
          <Tooltip title={text}>{text}</Tooltip>
        ),
    },

    
   
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (value, record) =>
        record.key === "categoryTotal" ? (
          <strong>{value}</strong>
        ) : value !== undefined ? (
          value.toFixed(decimalpoints)
        ) : (
          0
        ),
    },
    {
      title: "Total",
      dataIndex: "netTotal",
      key: "branchTotal",
      render: (value, record) =>
        record.key === "categoryTotal" ? (
          <strong>{value}</strong>
        ) : value !== undefined ? (
          value.toFixed(decimalpoints)
        ) : (
          0
        ),
    },
  ];
  
  const summaryColumns = [
    // {
    //   title: "Category",
    //   dataIndex: "category",
    //   key: "category",
    // },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category || "").localeCompare(b.category || ""), // A-Z sorting
      defaultSortOrder: "ascend", // Default to ascending order
    },
    {
      title: "Quantity",
      dataIndex: "totalQuantity",
      key: "quantity",
      render: (value, record) =>
        record.key === "categoryTotal" ? (
          <strong>{value}</strong>
        ) : value !== undefined ? (
          value.toFixed(decimalpoints)
        ) : (
          0
        ),
    },
    {
      title: "Total",
      dataIndex: "categoryTotal",
      key: "categoryTotal",
      render: (value) =>
        value !== undefined ? value.toFixed(decimalpoints) : 0,
    },
  ];
  
  function handleReset() {
    const today = dayjs(); // Get current date using dayjs

    setFromDate(today);
    setToDate(today);
    handleReportList();
    // setFromDate(null);
    // setToDate(null);
    setSearchText("");
    setreportData([]);
    // modifiedList = [];
    //  summaryData = [];
  }

  
  // const getActiveTabData = () => {
  //   let fieldMapping = {};

  //   const createfieldMapping = (columns) => {
  //     const mappings = {};
  //     columns.forEach((col) => {
  //       mappings[col.title] = col.dataIndex; // Map column title to its dataIndex
  //     });
  //     return mappings;
  //   };
  //   switch (activeTab) {
  //     case "1":
  //       fieldMapping = createfieldMapping(columns);
  //      // console.log("fieldMapping of first table:", fieldMapping);
  //       return { data: modifiedList,columns: columns, fieldMapping };
  //     case "2":
  //       fieldMapping = createfieldMapping(summaryColumns);
  //      // console.log("fieldMapping of second table:", fieldMapping);
  //       return { data: summaryData, columns: summaryColumns, fieldMapping };
  //     default:
  //       return { data: [], columns: [] };
  //   }
  // };


  
  const getActiveTabData = () => {
  const createFieldMapping = (columns) =>
    columns.reduce((mappings, col) => {
      mappings[col.title] = col.dataIndex;
      return mappings;
    }, {});

  const getSummaryRow = (columns, grandQuantity, grandTotal, decimalpoints) => {
    return columns.map((col, index) => {
      if (index === 0) return "Grand Total";
      if (index === 2) return (grandQuantity ?? 0).toFixed(decimalpoints);
      if (index === 3) return (grandTotal ?? 0).toFixed(decimalpoints);
      return "";
    });
  };
  const getSummaryRows = (summaryColumns, totalQuantity, categoryGrandTotal, decimalpoints) => {
    return summaryColumns.map((col, index) => {
      if (index === 0) return "Grand Total";
      if (index === 1) return (totalQuantity ?? 0).toFixed(decimalpoints);
      if (index === 2) return (categoryGrandTotal ?? 0).toFixed(decimalpoints);
      return "";
    });
  };

// Sorting functions
const sortByBillDate = (data) =>
  [...data].sort((a, b) => {
    const dateA = new Date(a.billdate).getTime() || 0;
    const dateB = new Date(b.billdate).getTime() || 0;
    return dateA - dateB; // Ascending order (oldest first)
  });

const sortByCategory = (data) =>
  [...data].sort((a, b) => (a.category || "").localeCompare(b.category || "")); // A-Z sorting

  switch (activeTab) {
    case "1":
      return {
        // data: modifiedList,
        data: sortByBillDate(sortByCategory(modifiedList)),
        columns: columns,
        Rname:"Category Sales Reports",
        fieldMapping: createFieldMapping(columns),
        summaryRow: getSummaryRow(columns, grandQuantity, grandTotal, decimalpoints),
      };
    case "2":
      return {
        data: summaryData,
        columns: summaryColumns,
        Rname:"Category Summary Reports",
        fieldMapping: createFieldMapping(summaryColumns),
        summaryRows: getSummaryRows(summaryColumns, totalQuantity, categoryGrandTotal, decimalpoints),
      };
    default:
      return { data: [], columns: [], fieldMapping: {}, summaryRow: [],summaryRows: [] };
  }
};

// const createFieldMapping = (columns) =>
//   columns.reduce((mappings, col) => {
//     mappings[col.title] = col.dataIndex;
//     return mappings;
//   }, {});

// const getSummaryRow = (columns, grandQuantity = 0, grandTotal = 0, decimalpoints = 2) => {
//   return columns.map((col, index) => {
//     if (index === 0) return "Grand Total";
//     if (index === 2) return grandQuantity.toFixed(decimalpoints);
//     if (index === 3) return grandTotal.toFixed(decimalpoints);
//     return "";
//   });
// };

// // Sorting functions
// const sortByBillDate = (data) =>
//   [...data].sort((a, b) => {
//     const dateA = new Date(a.billdate).getTime() || 0;
//     const dateB = new Date(b.billdate).getTime() || 0;
//     return dateA - dateB; // Ascending order (oldest first)
//   });

// const sortByCategory = (data) =>
//   [...data].sort((a, b) => (a.category || "").localeCompare(b.category || "")); // A-Z sorting

// const getActiveTabData = (activeTab, modifiedList, columns, grandQuantity, grandTotal, decimalpoints, summaryData, summaryColumns) => {
//   switch (activeTab) {
//     case "1":
//       return {
//         data: sortByBillDate(sortByCategory(modifiedList)), // Apply sorting
//         columns,
//         fieldMapping: createFieldMapping(columns),
//         summaryRow: getSummaryRow(columns, grandQuantity, grandTotal, decimalpoints),
//       };
//     case "2":
//       return {
//         data: sortByBillDate(sortByCategory(summaryData)), // Apply sorting
//         columns: summaryColumns,
//         fieldMapping: createFieldMapping(summaryColumns),
//         summaryRow: getSummaryRow(summaryColumns, grandQuantity, grandTotal, decimalpoints),
//       };
//     default:
//       return { data: [], columns: [], fieldMapping: {}, summaryRow: [] };
//   }
// };

  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Category Sales Reports</h4>
                <h6>Manage Sales Category reports here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <Link
                    onClick={() =>
                      exportMasterPDF(getActiveTabData,companyInfolist, "Category wise Report")
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <Link
                    onClick={() =>
                      exportMasterExcel(getActiveTabData,companyInfolist, "Category wise Report")
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <Link
                    onClick={() =>
                      printMasterReport(getActiveTabData,companyInfolist,"Category wise Report")
                    }
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Refresh")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={() => handleReportList()}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top ">
                <div className="search-set">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div
                      id="DataTables_Table_0_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        {" "}
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-blocks">
                        <label>From Date</label>
                        <DatePicker
                          id="from-date"
                          placeholderText="From Date"
                          value={fromDate}
                          onChange={handleFromDateChange}
                          startDate={fromDate}
                          selectsStart
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-blocks">
                        <label>To Date</label>
                        <DatePicker
                          id="to-date"
                          placeholderText="To Date"
                          value={toDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          startDate={fromDate}
                          selectsEnd
                          disabled={!fromDate} // disable until from date is selected
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-blocks p-3 mt-3">
                    <Link
                      className="btn btn-filters rounded-2 "
                      onClick={handleReportList}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      Search{" "}
                    </Link>
                  </div>
                  <div className="input-blocks mt-3">
                    <button
                      className="btn btn-reset  rounded-2 "
                      onClick={handleReset}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Tabs defaultActiveKey="1" onChange={handleTabChange}>
                  <TabPane tab="Detailed View" key="1">
                    {/* <Table columns={columns}
                     dataSource={modifiedList}
                    /> */}
                    <Table
  columns={columns}
  dataSource={modifiedList}
  pagination={true}
  summary={() => (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0}><strong>Grand Total</strong></Table.Summary.Cell>
      <Table.Summary.Cell index={1} />
      <Table.Summary.Cell index={2}>
        <strong>{grandQuantity.toFixed(decimalpoints)}</strong>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={3}>
        <strong>{grandTotal.toFixed(decimalpoints)}</strong>
      </Table.Summary.Cell>
    </Table.Summary.Row>
  )}
/>

                   

                  </TabPane>
                  <TabPane tab="Summary View" key="2">
                    {/* <Table columns={summaryColumns} dataSource={summaryData} /> */}
                    <Table
  columns={summaryColumns}
  dataSource={summaryData}
  pagination={true}
  summary={() => (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0}><strong>Grand Total</strong></Table.Summary.Cell>
      
      <Table.Summary.Cell index={1}>
        <strong>{totalQuantity.toFixed(decimalpoints)}</strong>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={2}>
        <strong>{categoryGrandTotal.toFixed(decimalpoints)}</strong>
      </Table.Summary.Cell>
    </Table.Summary.Row>
  )}
/>
                  </TabPane>
                </Tabs>
              </div>
               <div className="footerComment ml-3"> <b>* Please be informed that there will be a difference between the item-wise sales report and other sales reports if a bill-wise discount is applied.<br></br>*Extra charge amounts are not included <br></br>*Complimentary given amounts are added</b></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CategorySalesReport;